module.exports = __webpack_public_path__ + "img/linkedin-like.d7affa62.png";